import { useState, useMemo, useCallback } from "react";
import { useDebounce } from "@/hooks/useDebounce";

export const useCustomerFilters = () => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  
  const [view, setView] = useState("assign");
  const [viewStyle, setViewStyle] = useState("table");
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("newest");
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  
  const today = new Date().toISOString().split('T')[0];
  
  const [filters, setFilters] = useState({
    status: "all",
    activityStatus: "all",
    source: "all",
    location: "all",
    assignee: "all",
    date: "all",
    dateField: "createdAt",
    fromDate: "",
    toDate: ""
  });

  const handleFilterChange = useCallback((key, value) => {
    if (typeof key === 'object') {
      setFilters(prev => ({ ...prev, ...key }));
    } else {
      setFilters(prev => ({ ...prev, [key]: value }));
    }
    setPage(1); // Reset to first page on filter change
  }, []);

  return {
    search, setSearch,
    debouncedSearch,
    view, setView,
    viewStyle, setViewStyle,
    page, setPage,
    sortBy, setSortBy,
    filters, 
    setFilters: handleFilterChange,
    showAdvancedFilters, setShowAdvancedFilters
  };
};
